export const getArchiveExtension = name => {
  if (!name) return undefined;
  return name.split('.').pop();
};
export const getArchiveIcon = name => {
  const defaults = {
    icon: 'mdi mdi-file-document text-blue',
    hasPreview: false
  };
  if (!name) return defaults;
  const ext = getArchiveExtension(name);
  if (!ext) return defaults;
  switch (ext.toLowerCase()) {
    case 'pdf':
      return {
        icon: 'mdi mdi-file-pdf-box text-dark-red',
        hasPreview: true
      };
    case 'html':
      return {
        icon: 'mdi mdi-language-html5 text-orange',
        hasPreview: true
      };
    case 'txt':
      return {
        icon: 'mdi mdi-file-document text-blue',
        hasPreview: true
      };
    case 'sass':
    case 'scss':
      return {
        icon: 'mdi mdi-sass text-light-pink',
        hasPreview: false
      };
    case 'css':
      return {
        icon: 'mdi mdi-language-css3 text-orange',
        hasPreview: true
      };
    case 'xhtml':
    case 'xml':
      return {
        icon: 'mdi mdi-xml text-dark-orange',
        hasPreview: true
      };
    case 'csv':
      return {
        icon: 'mdi mdi-comma-box text-light-purple',
        hasPreview: true
      };
    case 'json':
      return {
        icon: 'mdi mdi-code-json text-yellow',
        hasPreview: true
      };
    case 'doc':
    case 'docx':
      return {
        icon: 'mdi mdi-file-word-box text-dark-blue',
        hasPreview: false
      };
    case 'xls':
    case 'xlsx':
      return {
        icon: 'mdi mdi-file-excel-box text-dark-green',
        hasPreview: false
      };
    case 'ppt':
    case 'pptx':
      return {
        icon: 'mdi mdi-file-powerpoint-box text-dark-orange',
        hasPreview: false
      };
    case 'js':
      return {
        icon: 'mdi mdi-language-javascript text-yellow',
        hasPreview: false
      };
    case 'rtf':
    case 'odp':
    case 'ods':
    case 'odt':
      return defaults;
    case 'zip':
      return {
        icon: 'mdi mdi-zip-box text-light-green',
        hasPreview: true
      };
    case '7z':
    case 'tar':
    case 'rar':
      return {
        icon: 'mdi mdi-zip-box text-light-green',
        hasPreview: false
      };
    case 'tiff':
    case 'tif':
    case 'cr2':
    case 'nef':
    case 'dng':
      return {
        icon: 'mdi mdi-image text-light-purple',
        hasPreview: true
      };
    case 'png':
    case 'jpeg':
    case 'jpg':
    case 'jfif':
    case 'webp':
    case 'gif':
    case 'ico':
    case 'bmp':
      return {
        icon: 'mdi mdi-image text-green',
        hasPreview: true
      };
    case 'svg':
      return {
        icon: 'mdi mdi-svg text-yellow',
        hasPreview: true
      };
    case 'avi':
    case 'mpeg':
    case 'mp4':
    case 'ogg':
    case 'ogv':
    case 'webm':
      return {
        icon: 'mdi mdi-video-box text-light-orange',
        hasPreview: true
      };
    case 'wmv':
    case '3gp':
    case '3gp2':
      return {
        icon: 'mdi mdi-video-box text-light-orange',
        hasPreview: false
      };
    case 'oga':
    case 'weba':
    case 'mp3':
    case 'wav':
      return {
        icon: 'mdi mdi-volume-high text-red',
        hasPreview: false
      };
    default:
      return defaults;
  }
};